import React from 'react';
import '../portalV2Shared.css';
import './UsanaLoginV2.css';

/**
 * Visual shell for SSO handoff. Classic UsanaLogin / ShopifyLogin still
 * process the token; when Portal V2 is enabled, currentUserStep sends
 * users to V2 destinations. This route is available for a branded wait state.
 * Route: /Usana/UsanaLogin-v2 (optional companion) — primary SSO URLs unchanged.
 */
const SsoHandoffV2 = ({ title = 'Signing you in', subtitle }) => (
    <div className="pv2 pv2-sso">
        <div className="pv2-sso__card pv2-glass pv2-glass--strong pv2-anim">
            <div className="pv2-sso__pulse" aria-hidden />
            <p className="pv2-eyebrow">Secure sign-in</p>
            <h1 className="pv2-title">{title}</h1>
            <p className="pv2-sub">
                {subtitle ||
                    'One moment while we verify your account and open your portal.'}
            </p>
        </div>
    </div>
);

export default SsoHandoffV2;
